import type { OrderFrequency } from "@jti/fe-common";
import { truncateText } from "@jti/fe-common";
import { Tooltip } from "@jti/ui/components/Tooltip";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import styles from "../../SticksForm.module.scss";

const MAX_TOOLTIP_LENGTH = 130;

type OrderFrequencyGroupTitleProps = {
  step: number;
  orderFrequency: OrderFrequency;
};

export const OrderFrequencyGroupTitle = ({ step, orderFrequency }: OrderFrequencyGroupTitleProps) => {
  const { __ } = useTranslations();

  const purchaseModeTooltipText = __(`product.info.purchaseMode.${orderFrequency}`);

  return (
    <>
      <strong className={styles.stepCountLabel}>{__(`sticksForm.step.order_text.${step}`)}</strong>
      &nbsp;
      {__("sticksForm.step.purchase_options.title")}
      &nbsp;
      <div className={styles.consumablesPurchaseTypeSectionTitleTooltipWrapper}>
        <Tooltip
          content={<span>{truncateText(purchaseModeTooltipText, MAX_TOOLTIP_LENGTH)}</span>}
          size="small"
          withCloseIcon
        />
      </div>
    </>
  );
};
